import { DateTime } from 'luxon';

export default function BlogDate({ date, showDate = false }) {
  const postDate = date ? new Date(date) : null;
  const formattedMonth = DateTime.fromJSDate(postDate).toFormat('MMM');
  const formattedDay = DateTime.fromJSDate(postDate).toFormat('dd');
  const formattedYear = DateTime.fromJSDate(postDate).toFormat('yyyy');
  return (
    !showDate &&
    date && (
      <div className="bg-[#F6DFFF] inline-block rounded-[50px] py-1 px-3 text-[14px] font-[500]">
        {formattedDay} {formattedMonth} {formattedYear}
      </div>
    )
  );
}
